import { createSelector } from '@reduxjs/toolkit';
import { selectBulk } from '../selectors';
import { BulkState } from '../types';

export const selectOrder = createSelector(selectBulk, (bulkState: BulkState) => bulkState.order);
